<template>
  <div>
    <div>
      <el-form class="reports-create" label-position="top">
        <div class="reports-edit-header" v-if="$route.params.id && $route.name !== 'tasksCopy'">
          <div @click="deleteReport" class="i-container" v-if="isEditable">
            <i class="el-icon-delete"></i>
            <span>Удалить задачу</span>
          </div>
          <router-link
            :to="`/dashboard/tasks/create/${$route.params.id}/copy`"
            class="i-container"
          >
            <i class="el-icon-document-copy"></i>
            <span>Копировать задачу</span>
          </router-link>
          <div class="i-container" v-clipboard:copy="link" v-clipboard:success="onCopy">
            <i class="fa  fa-link" style="font-size: 20px"></i>
            <span>Скопировать ссылку</span>
          </div>
        </div>
        <div class="date-create">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            v-model="form.datetime"
            type="date"
            :disabled="!isEditable"
            placeholder="Укажите дату"
          >
          </el-date-picker>
          <h4>
            <small>Номер задачи</small>
            #{{ form.index }}
          </h4>
        </div>

        <div>
          <div class="add-btn">
            <AddObjects
              v-if="isEditable"
              :isSelect="!!form.object"
              @add-objects="addObject"
            />
            <div class="report-li-title" v-if="form.object">
              Выбранный объект: <strong>{{ ` ` + form.object.name }}</strong>
            </div>
          </div>

          <div class="add-btn">
            <AddCategory
              v-if="isEditable"
              :isSelect="!!form.category"
              @add-category="addCategory"
            />
            <div class="report-li-title" v-if="form.category">
              Выбранная категория: <strong>{{ ` ` + form.category.name }}</strong>
            </div>
          </div>

          <div class="add-btn">
            <AddUser
              v-if="isEditable"
              :isSelect="!!form.executor"
              @add-user="addUser"
            />
            <div class="report-li-title" v-if="form.executor">
              Выбранный исполнитель: <strong>{{ ` ` + form.executor.name }}</strong>
            </div>
          </div>

          <div style="margin-top: 20px">
            <filter-select
              :disabled="!isEditable"
              multiple
              v-model="form.notifications"
              label="Уведомить"
              :options="allUsers"
            />
          </div>
        </div>
        <el-form-item label="Срок исполнения">
          <el-date-picker
            :editable="false"
            :disabled="!isEditable"
            format="yyyy-MM-dd"
            v-model="form.deadline_datetime"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>

        <div class="create-comment">
          <el-form-item label="Заголовок задачи">
            <el-input v-model="form.title" :disabled="!isEditable"
            ></el-input>
          </el-form-item>

          <el-form-item label="Описание задачи">
            <el-input type="textarea" :disabled="!isEditable"
                      v-model="form.description"></el-input>
          </el-form-item>
        </div>

        <el-form-item label="Нормативные документы">
          <el-input type="textarea" :disabled="!isEditable"
                    v-model="form.normative_docs"></el-input>
        </el-form-item>
        <div class="report-file">
          <UploadFile
            v-if="isEditable"
            :fileListProps="fileList"
            @add-file="addFile"
          />
          <div :key="index" v-for="(file, index) in form.files" class="links-list">
            <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
            <i class="el-icon-delete" @click="deleteImg(index)" v-if="isEditable"></i>
          </div>
        </div>


        <div class="create-comment">
          <el-form-item label="Комментарии">
            <Comments ref="comment" v-model="comment.text" :form="form" :all-users="allUsers" :user="user"/>
          </el-form-item>
          <div class="report-file">
            <UploadFile
              :fileListProps="fileList"
              @add-file="addFileComment"
            />
            <div :key="index" v-for="(file, index) in comment.files" class="links-list">
              <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
              <i class="el-icon-delete" @click="deleteTmpImg(index)"></i>
            </div>
          </div>
          <el-button type="primary" style="margin-top: 10px; width: 100%" @click="addComment">Добавить комментарий
          </el-button>
          <div style="margin-top: 50px; margin-bottom: 40px">
            <div v-for="(comment, key) in form.comments" :key="key" class="comments">
              <div class="comment">
                <div class="text">
                  <div class="desc">
                    <strong>{{ comment.user.name || comment.user.email }}: </strong>
                    <span>&nbsp;&nbsp;{{ ` ${comment.text}` }}</span>
                  </div>
                  <a @click="deleteComment(key)" v-if="comment.user.uid === user.uid || user.role === 'admin'"
                     class="delete-btn">Удалить</a>
                </div>
                <div :key="index" v-for="(file, index) in comment.files" class="links-list">
                  <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
                  <i class="el-icon-delete" v-if="comment.user.uid === user.uid || user.role === 'admin'"
                     @click="deleteCommentImg(key, index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <div class="create-footer">
          <div style="width: 100%;">
            <div style="display:flex; justify-content: space-between; flex-direction: column">
              <el-date-picker
                v-if="form.status && (form.status.value === 'DONE' || form.status.value === 'IN_TEST')"
                :editable="false"
                style="margin: 0 0 10px 0"
                format="yyyy-MM-dd HH:mm:ss"
                v-model="form.finish_datetime"
                type="datetime"
                placeholder="Укажите дату"
              ></el-date-picker>
              <filter-select
                v-model="form.status"
                label="Статус задачи"
                hideLabel
                :disabled="!isExecutor && !isEditable"
                @input="setStatus"
                :options="status_options"
              />
            </div>

            <div style="display:flex; justify-content: space-between">
              <el-button @click="back">Отмена</el-button>
              <el-button type="primary" @click="save">Сохранить</el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import AddObjects from '../Reports/components/AddObjects';
import UploadFile from '@/views/Dashboard/Reports/components/UploadFile';
import firebase from 'firebase';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import FilterSelect from '../../../components/FilterSelect';
import AddCategory from "./components/AddCategory";
import AddUser from "./components/AddUser";
import {getRole, getUsersOptions} from "../../../firestore/users";
import VueTribute from 'vue-tribute'
import Comments from "./Comments";
import {uniq} from "lodash";
import th from "vue2-datepicker/locale/es/th";

export default {
  name: 'Create',
  components: {Comments, AddUser, AddCategory, FilterSelect, UploadFile, AddObjects, Multiselect, VueTribute},
  data() {
    return {
      searchable: {
        line: false,
      },
      comment: {
        text: '',
        files: [],
      },
      updated: true,
      fileList: [],
      tributeOptions: {
        trigger: '@',
        noMatchTemplate: () => '<li>Пользователь не найден</li>',
        values: (text, cb) => this.getNames(text, cb)
      },
      loader: false,
      dialogObject: false,
      previewSrc: null,
      loading: true,
      isCreatedUser: false,
      user: {},
      current_line: {},
      allUsers: [],
      options_works: [],
      role: 'admin',
      form: {
        notifications: [],
        normative_docs: '',
        status: '',
        datetime: dayjs().format(),
        dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
        deadline_datetime: dayjs().format(),
        deadline_dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
        finish_datetime: null,
        finish_dateunix: null,
        comments: [],
        title: '',
        description: '',
        object: '',
        executor: '',
        category: '',
        index: 1,
        files: [],
      },
    };
  },

  async mounted() {
    setTimeout(() => this.init(), 0);
    this.role = await getRole(this.$store.state.project.id);

    const users = await getUsersOptions(this.$store.state.project.id, true)
    this.allUsers = users.filter((u) => !u._data.isCompany)
  },
  watch: {
    '$route.params': {
      handler() {
        this.init();
      },
      deep: true,
    },
  },

  computed: {
    isExecutor() {
      const reporter = this.form.executor || {}
      const uid = authFirestore.currentUser.uid;

      if (this.role === 'editor' && this.form.executor.name === this.user.company) {
        return true
      }

      return reporter.uid === uid || reporter.id === uid
    },
    link() {
      return window.location.href;
    },
    isEditable() {
      if ((this.form.user && this.form.user.uid) === authFirestore.currentUser.uid) {
        return true
      }

      return this.role === 'admin' || !this.$route.params.id;
    },
    status_options() {
      const result = [
        {
          label: 'В работе',
          value: 'IN_PROGRESS',
        },
        {
          label: 'Выполнено',
          value: 'IN_TEST',
        }
      ]

      if (this.isEditable) {
        result.push({
          label: 'Завершено',
          value: 'DONE',
        })
      }

      return result;
    }
  },

  methods: {
    getNames(t, sb) {
      const users = this.allUsers;

      const result = []
      const user = this.form.user || {}
      const reporter = this.form.executor || {}

      users.forEach(({label, value}) => {
        if (this.form.notifications.find((u) => u.value === value) || user.uid === value || reporter.uid === value || authFirestore.currentUser.uid === value) {
          result.push({
            value: label,
            key: label
          })
        }
      })

      sb([
        {key: 'Все', value: 'Все'},
        ...result
      ])
    },
    async back() {
      await this.$router.push(`/dashboard/tasks`)
    },
    onCopy() {
      this.$notify.success({
        offset: 60,
        title: 'Ссылка скопирована',
      });
    },
    async addObject(n) {
      this.form.object = n;
    },
    setStatus(status) {
      if (status.value === 'DONE' || status.value === 'IN_TEST') {
        if (!this.form.finish_dateunix || isNaN(this.form.finish_dateunix)) {
          this.form.finish_datetime = dayjs().format();
          this.form.finish_dateunix = dayjs(dayjs().format()).utc().unix()
        }
      }
    },
    deleteComment(i) {
      this.form.comments.splice(i, 1)

      this.updateComments();
    },
    deleteCommentImg(key, i) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const comments = [...this.form.comments];
        comments[key].files.splice(i, 1);
        this.form.comments = comments;

        this.updateComments();

      });
    },
    addComment() {
      const comments = this.form.comments || [];

      comments.push({
        ...this.comment,
        user: this.user,
        emails: this.getCommentEmails(this.comment)
      })

      this.comment = {
        text: '',
        files: []
      }

      this.form.comments = comments;
      this.updateComments();

      this.$refs.comment.clearValue()
    },
    getCommentEmails(comment) {
      const result = []

      this.allUsers.forEach(({label, _data}) => {
        if(comment.text.includes(label)) {
          result.push(_data.email)
        }
      })

      return uniq(result)
    },
    updateComments() {
      if (this.$route.params.id) {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('tasks')
          .doc(this.$route.params.id)
          .update({
            comments: this.form.comments,
          });
      }
    },
    addCategory(n) {
      this.form.category = n;
    },
    addUser(n) {
      this.form.executor = n;
    },
    async init() {
      this.fetchUser();
      if (this.$route.params.id) {
        await this.fetchData();
        if (this.$route.name === 'tasksCopy') {
          this.fetchIndex();
          this.form.datetime = dayjs().format();
        }
      } else {
        this.fetchIndex();
      }
    },
    sendReport() {
      this.$prompt('Пожалуйста введите email', 'Отправка задачи', {
        confirmButtonText: 'Отправить',
        inputValue: authFirestore.currentUser.email,
        cancelButtonText: 'Закрыть',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Некорректный емайл',
      }).then(({value}) => {
        this.loading = true;
        const proxy = firebase.functions().httpsCallable('onMailReports');
        proxy(
          {
            projectId: this.$store.state.project.id,
            reportId: this.$route.params.id,
            email: value,
          },
        ).then(() => {
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Задача отправлена на почту',
            type: 'success',
          });
        }).catch(() => {
          this.$notify({
            offset: 60,

            title: 'Ошибка',
            message: 'Произошла ошибка, попробуйте позже',
            type: 'error',
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    deleteReport() {
      this.$confirm('Вы действительно хотите удалить это задание?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('tasks')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Задание удалено',
              type: 'success',
            });
            setTimeout(() => {
              this.$router.push('/dashboard/tasks');
            }, 1000);
          });
      });
    },
    fetchUser() {
      this.loading = true;
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || authFirestore.currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const user = subDoc.data();
            if (user.name && user.position && user.position.length) {
              this.isCreatedUser = subDoc.id;
            }
            this.user = {
              ...user,
              name: user.name || authFirestore.currentUser.email,
              user_profile_id: subDoc.id,
            };
          });

        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    preview(file) {
      window.open(file, '_blank');
    },
    addFile(f) {
      this.form.files.push(f);
    },
    addFileComment(f) {
      this.comment.files.push(f);
    },
    deleteTmpImg(i) {
      const comment = {...this.comment};
      comment.files.splice(i, 1);
      this.comment = comment;
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    fetchData() {
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('tasks')
        .doc(this.$route.params.id)
        .get().then((data) => {
          const subData = data.data();
          this.fileList = this.form.files.map((f, i) => {
            return {
              url: f,
              name: 'file__' + i,
            };
          });

          this.form = {
            ...this.form,
            ...this.comment,
            ...subData,
          };
        });
    },
    fetchIndex() {
      return new Promise((resolve, reject) => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('tasks')
          .orderBy('index', 'desc').limit(1)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((data) => {
              this.form.index = Number(data.data().index) + 1;
            });
            resolve();
          });
      });
    },
    async save() {
      if (this.loader) return false;

      this.loader = true;

      if (!this.form.datetime) {
        this.$notify({
          offset: 60,

          title: 'Заполните все поля!',
          message: 'Пожалуйста заполните поле c датой',
          type: 'error',
        });
        return;
      }

      const user = authFirestore.currentUser;

      if (!this.$route.params.id || this.$route.name === 'tasksCopy') {
        await this.fetchIndex();
        user.providerData.forEach(() => {
          myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('tasks')
            .add({
              ...this.form,
              userId: this.$store.state.company.uid || user.uid,
              user: this.user,
              datetime: dayjs(this.form.datetime).format(),
              dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              deadline_datetime: dayjs(this.form.deadline_datetime).format(),
              deadline_dateunix: dayjs(dayjs(this.form.deadline_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
              finish_datetime: dayjs(this.form.finish_datetime).format(),
              finish_dateunix: dayjs(dayjs(this.form.finish_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            }).then(() => {
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Задача добавлена',
              type: 'success',
            });
            setTimeout(() => {
              this.fetchIndex();
              this.$router.push('/dashboard/tasks/');
            }, 1000);
          }).finally(() => {
            this.loader = true;
          })
            .catch((error) => {
              this.$notify({
                offset: 60,

                title: 'Упс... ',
                message: 'Произошла ошибка повторите позже',
                type: 'error',
              });
            });
        });
      } else {

        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('tasks')
          .doc(this.$route.params.id)
          .update({
            ...this.form,
            toUserId: (this.form.executor && this.form.executor.id) || null,
            datetime: dayjs(this.form.datetime).format(),
            dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            deadline_datetime: dayjs(this.form.deadline_datetime).format(),
            deadline_dateunix: dayjs(dayjs(this.form.deadline_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            finish_datetime: dayjs(this.form.finish_datetime).format(),
            finish_dateunix: dayjs(dayjs(this.form.finish_datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
          }).then(() => {
          this.$router.push('/dashboard/tasks');

          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Задача отредактирована',
            type: 'success',
          });
        }).finally(() => {
          this.loader = true;
        }).catch((error) => {
          this.$notify({
            offset: 60,

            title: 'Упс... ',
            message: 'Произошла ошибка повторите позже',
            type: 'error',
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
.tribute-container {
  background: #fff;
  z-index: 999;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 0;

  ul {
    list-style-type: none;
    padding-inline-start: 0px;
    margin-block-start: 0px;
    margin-block-end: 0px;

    li {
      padding: 8px 16px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        background: #409EFF;
        color: #fff;
      }
    }
  }
}
</style>
<style scoped lang="scss">

.navigate-btn {
  margin-top: 20px;
  display: block;
}

.reports-create, .alert-report {
  margin: 0 auto;
  max-width: 382px;
  padding-top: 20px;
  width: calc(100% - 40px);
  overflow: hidden;
  padding-bottom: 100px;

  .add-jobs {
    display: flex;
    flex-direction: column;
  }

  .date-create {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h4 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0;

    small {
      font-size: 10px;
      font-weight: 400;
    }
  }
}

.add-btn {
  width: 100%;

  > > > .add {
    width: 100%;
  }

  margin-top: 20px;

  &.add-jobs {
    margin-top: 0;
  }
}

.select-job {
  margin-top: 20px;

  > > > .el-select {
    width: 100%;
  }
}

.report-li {
  span {
    max-width: 50%;
  }
}

.report-value {
  strong {
    font-weight: bold;
  }
}

@media screen and (max-width: 500px) {
  .report-value {
    width: 100%;
    justify-content: space-between !important;
  }

  .report-li {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;


    .el-icon-close {
      margin-bottom: 12px;
    }

    .col-vo, .time {
      display: flex;
      flex-direction: row;

      > > > .el-form-item__label {
        margin-right: 6px !important;
      }
    }

    .time {
      margin-left: 10px;
    }

    span {
      max-width: 100%;
      font-weight: bold;
    }
  }
}

.report-li-title {
  font-size: 14px;
  margin-top: 18px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0px;
}

.report-add-job {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding: 20px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  .report-ul {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 22px;
  }

  .jobs-li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:last-child {
      border-bottom: none;
    }

    padding-bottom: 12px;
  }

  .report-li {
    display: flex;
    margin-top: 3px;
    justify-content: space-between;
    min-height: 58px;
    padding: 12px 0px;
    text-align: left;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;


    &.with-check {
      border-bottom: none;
      padding-bottom: 0px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.report-file {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-top: 18px;
}


.create-footer {
  display: flex;
  justify-content: center;
  //padding-bottom: 34px; // IOS ONLY
  padding-bottom: 7px;

  position: fixed;
  border-top: 1px solid #ddd;
  align-items: center;
  padding-top: 10px;
  max-width: 382px;
  width: calc(100% - 40px);
  bottom: 0;
  background: #fff;
  z-index: 3;

  .el-form-item {
    margin-bottom: 8px !important;
  }
}

.report-ul {
  width: 100%;
}

> > > .el-form-item, > > > .el-form-item__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .el-form-item__label {
    padding: 0 !important;
  }
}

.docs {
  > > > .el-form-item__content {
    align-items: flex-start;
  }
}

> > > .el-form-item {
  margin-bottom: 10px !important;
}

.report-value {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  strong {
    opacity: 0.8;
    font-weight: bold;
  }

  > > > .el-input__inner {
    width: 92px;
    text-align: right;
    margin-right: 8px;
  }


}

.preview-images {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
  margin-top: 16px;
  margin-bottom: 16px;

  .preview-img {
    width: 92px;
    height: 92px;
    margin: 6px;
  }

  .controls {
    display: flex;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.3);
    width: 92px;
    height: 92px;
    border-radius: 6px;
    margin-top: -98px;
    z-index: 2;
    position: relative;
    align-items: center;

    i {
      font-size: 24px;
      color: #fff;
      margin: 0 12px;
      cursor: pointer;
    }
  }

  img {
    width: 92px;
    height: 92px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
    position: relative;
  }
}

.add-block {
  display: flex;
  justify-content: flex-end;
}

.line-data {
  padding: 5px 15px;
  margin-bottom: 10px;
  background: #fff;
  background: #f7f7f7;
  box-shadow: 0px 0px 8px 0px #ccc;
  border-radius: 5px;
}

.pipe-close {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: -42px;
  margin-top: 10px;
  font-size: 20px;
  cursor: pointer;

  i {
    margin-bottom: 10px;
  }

  > > > .add-btn-joint {
    z-index: 2;
    position: relative;
  }
}

.reports-edit-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;

  .i-container {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    padding: 6px;
    cursor: pointer;
    border: 1px solid #eee;
    color: #000;
    text-decoration: none;
    flex-direction: column;

    i {
      height: 24px;
    }

    span {
      font-size: 10px;
      margin-top: 6px;
    }

    &:hover {
      background: #eee;
    }
  }
}

.reports-create {
  padding: 0 20px;
}

.add-job {
  margin-top: -30px;
}

.reports-create {
  padding-top: 40px;
  //padding-bottom: 160px; // IOS ONLY
  padding-bottom: 117px;
}

.report-add-job {
  .line-data {
    padding-top: 24px;
    margin-bottom: 20px;
  }

  .report-ul.mul {
    margin-bottom: 0;
  }

  .add-block {
    margin-top: 30px;
  }

  .report-li > > > .el-form-item__label {
    height: 32px;
  }

  .col-vo {
    > > > .el-input__inner {
      width: 68px !important;
      padding: 0 5px !important;
    }
  }

  .time {
    > > > .el-input__inner {
      width: 58px !important;
      padding: 0 8px 0 2px !important;
      margin-right: 0px;
    }
  }
}

.reports-mul {
  > > > .el-form-item__label {
    margin-top: 2px;
  }

  > > > .el-form-item {
    margin-bottom: 10px;
  }
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 14px;
}

.links-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  align-items: center;

  a {
    color: #3676cb;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  i {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.8;
  }
}

.comments {
  display: flex;
  flex-direction: column;

  .comment {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 0;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .text {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.delete-btn {
  font-size: 12px;
  color: #ff4500;
  cursor: pointer;
}

.desc {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Tasks/Create.vue